import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { ExpandedColumn } from "../types/columns";

const getExcelCellFormat = (type?: "number" | "date" | "datetime") => {
  switch (type) {
    case "number":
      return "#,##0.00";
    default:
      return undefined;
  }
};

type Props = {
  columns: ExpandedColumn[];
  fileName: string;
};

export const ExportExcelVehicles = forwardRef<ExcelExport, Props>(
  ({ columns, fileName }, ref) => {
    const { t } = useTranslation();
    return (
      <ExcelExport ref={ref} fileName={fileName}>
        {columns?.map((c) => {
          if (c.excel && c.excel.isVisible === false) return null;
          let width = c.width;
          if (c.excel && c.excel.width !== undefined) {
            width = c.excel.width;
          }
          const cellFormat = getExcelCellFormat(c.excel?.type);
          return (
            <ExcelExportColumn
              key={c.key}
              field={c.key}
              title={t(c.labelKey)}
              width={width}
              headerCellOptions={{
                background: "#235592",
                color: "#fff",
                textAlign: c.align ?? ("center" as any),
              }}
              cellOptions={{
                textAlign: c.align ?? ("center" as any),
                ...(cellFormat && { format: cellFormat }),
              }}
            />
          );
        })}
      </ExcelExport>
    );
  },
);
